<template>

<core-modal-setting title="Seen by" :value="valueText" placeholder="Not selected">
        
    <core-input-checklist 
        :options="options"
        v-model="internalValue"
    />

</core-modal-setting>

</template>

<script>

import mixSetting from 'core/mixin/modal/Setting'

export default {

    mixins: [mixSetting],

    computed: {

        options: function() {

			return [{
				value: 1,
				text: 'Everyone',
				description: 'Anyone viewing your profile can use it.'
			}, {
				value: 0,
				text: 'Only me',
				description: 'Only you can see and use it.'
			}]

        }

    }

}

</script>

<style scoped>

</style>